// extracted by mini-css-extract-plugin
export default {"Header":"Header-module__Header___e62hV"};